const doc = [({"zh_cn":({"adminCancelPolicyOption":({"fixedFee":"应用以下取消费用", "free":"免费取消费用", "original":"应用取消規則"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;